// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","fixed__arrow":"App_fixed__arrow__MRlqg","mover":"App_mover__TOsuh","show__arrow":"App_show__arrow__PLQ6Y"};